import { Tooltip } from '@lune-fe/lune-ui-lib'
import { ReactElement } from 'react'

const OnlyAPIClientsTooltip = ({
    children,
    contentWidth,
}: {
    children: ReactElement
    contentWidth?: boolean
}) => {
    return (
        <Tooltip title="Only API clients can do this" placement="top" contentWidth={contentWidth}>
            {children}
        </Tooltip>
    )
}

export default OnlyAPIClientsTooltip
